import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useRef,
} from "react";
import axios from "axios";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Typography,
  Paper,
  Divider,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  LinearProgress,
  List,
  ListItem,
  ListItemText,
  Button,
  Drawer,
  ListItemIcon,
  MenuItem,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Fade,
  Stack,
  Select,
  IconButton,
  AppBar,
  Toolbar,
  Slide,
  InputLabel,
  CssBaseline,
  ToggleButtonGroup,
  ToggleButton,
  Link,
  CircularProgress,
  Menu,
  TextField,
  InputAdornment,
  SvgIcon,
  Skeleton,
  Breadcrumbs,
  Chip,
  Tabs,
  Tab,
} from "@mui/material";
import {
  AttachMoney,
  Category,
  Business,
  TrendingUp,
  TrendingDown,
  Remove,
  PieChart,
  Close as CloseIcon,
  CloudUpload,
  Dashboard,
  FileDownload,
  CheckCircle,
  RadioButtonUnchecked,
  AccessTime,
  AutoAwesome,
  Campaign,
  Delete,
  ArrowDropDown,
  ArrowDropDownCircle,
  PriceCheck,
  CreditScore,
  CurrencyExchange,
  Info,
  Groups,
  PersonSearch,
  HelpOutline,
  Speed,
  PanToolAlt,
  TrendingFlat,
  PeopleAltOutlined,
  CampaignOutlined,
  FiberManualRecord,
  AccessTimeFilledOutlined,
  AccessTimeFilled,
  Co2,
  EnergySavingsLeaf,
  Insights,
  InsightsOutlined,
  ArrowUpward,
  ArrowDownward,
  HorizontalRule,
  TrendingUpOutlined,
  TrendingDownOutlined,
  TrendingFlatOutlined,
  FilterCenterFocus,
  TipsAndUpdates,
  NavigateNext,
  ReportProblem,
  CloseFullscreen,
  Close,
  OpenInNew,
  Toll,
  TrendingUpSharp,
  TrendingDownSharp,
  TrendingFlatSharp,
  LinkOffOutlined,
  LinkRounded,
  Visibility,
  ArrowOutward,
  PlayArrow,
} from "@mui/icons-material";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { RxDashboard } from "react-icons/rx";
import { RiBuildingLine } from "react-icons/ri";
import { Tooltip as MUITooltip } from "@mui/material";
import { LoadingGif } from "../LoadingGif";
import { AnimatedInfoCard } from "../LoadingGif";
import { SupplierChartFunc } from "../SupplierChart";
import { SupplierInsightContainer } from "../SupplierTable";
import { HistogramChart } from "../CategoryChart";
import { InsightContainer } from "../CategoryInsights";
import { CarbonChart } from "../CarbonEmissions";
import { CPOMarketInsights } from "../CPOMarketInsights";
import { CPOCommodityPriceChart } from "../CPOCommodityPriceChart";

const AnalyticsSectionCPO = ({
  heatmapChartData,
  costStructureMovements,
  categoryChartDataL1,
  topMovementsAnalysis,
  topcardCommentary,
  spendSummary,
  categorySummary,
  supplierSummary,
  roleTitle,
  filteredResults,
  categoryNews,
  globalSummaries,
  indiSummaries,
  categoryChartData,
  carbonEmission,
  carbonTable,
  supplierChartData,
  top3CategoriesSup,
  supDandP,
  supCustInfo,
  riskScore,
  scoreCommentary,
  revenue,
  supplierNews,
  supplierProData,
  kpdbData,
  cardsCPO,
  cardsCPO1,
  cardsCPO2,
  cardsCPO3,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const toggleExpand = () => {
    setOpenDialog(true);
    console.log("toggleExpand is called");
  };
  const handleClose = () => setOpenDialog(false);

  const [selectedView, setSelectedView] = useState("keyInsights");

  const handleToggleChange = (event, newValue) => {
    if (newValue !== null) {
      setSelectedView(newValue);
    }
  };

  return (
    <Box
      sx={{
        flexGrow: 1,
        paddingRight: "24px",
        // bgcolor: "#181921",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        marginTop: "10px",
        width: "100%",
      }}
    >
      {/* Company Details Section */}
      {/* <Box
    id="Company Details"
    style={{
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: "100%",
    }}
  >
    <Typography
      sx={{
        fontStyle: "Roboto",
        fontSize: "18px",
        fontWeight: 700,
        lineHeight: "18px",
        color: "white",
      }}
    >
      <Info sx={{ mr: 0.5 }} /> Company Details
    </Typography>
    <Box sx={{ width: "100%", height: "1px", mb: 2 }} />
    <Box sx={{ width: "100%" }}>
      {clientInsights ? (
        <Box
          sx={{
            mb: 2,
            display: "flex",
            background: "#FFFFFF08",
            color: "white",
            justifyContent: "space-between",
            border: "1px solid #2C2D3C",
            borderRadius: "8px",
            width: "100%",
            padding: "16px",
            fontSize: "14px",
            boxShadow: "0px 1px 2px 0px #1018280D",
          }}
        >
          <Typography
            sx={{
              fontStyle: "Roboto",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "20px",
              textAlign: "left",
            }}
          >
            {clientInsights}
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "240px", // Adjust height as needed
          }}
        >
          <LoadingGif />
        </Box>
      )}
    </Box>
  </Box> */}

      {/* Summary Section */}
      <Box
        id="Company Details"
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "100%",
        }}
      >
        <Box sx={{ width: "100%", height: "1px", mb: 2 }} />
        <Box sx={{ width: "100%" }}>
          {/* {clientInsights ? (
        <Box
          sx={{
            mb: 2,
            display: "flex",
            background: "#FFFFFF08",
            color: "white",
            justifyContent: "space-between",
            border: "1px solid #2C2D3C",
            borderRadius: "8px",
            width: "100%",
            padding: "16px",
            fontSize: "14px",
            boxShadow: "0px 1px 2px 0px #1018280D",
          }}
        >
          <Typography
            sx={{
              fontStyle: "Roboto",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "20px",
              textAlign: "left",
            }}
          >
            {clientInsights}
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "240px", // Adjust height as needed
          }}
        >
          <LoadingGif />
        </Box>
      )} */}

          {/* Summary Section */}
          <Box
            id="Company Details"
            style={{
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              width: "100%",
            }}
          >
            <Box sx={{ width: "100%", height: "1px", mb: 2 }} />
            <Box sx={{ width: "100%" }}>
              {/* {clientInsights ? (
        <Box
          sx={{
            mb: 2,
            display: "flex",
            background: "#FFFFFF08",
            color: "white",
            justifyContent: "space-between",
            border: "1px solid #2C2D3C",
            borderRadius: "8px",
            width: "100%",
            padding: "16px",
            fontSize: "14px",
            boxShadow: "0px 1px 2px 0px #1018280D",
          }}
        >
          <Typography
            sx={{
              fontStyle: "Roboto",
              fontSize: "14px",
              fontWeight: 500,
              lineHeight: "20px",
              textAlign: "left",
            }}
          >
            {clientInsights}
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "240px", // Adjust height as needed
          }}
        >
          <LoadingGif />
        </Box>
      )} */}

              <Box
                sx={{
                  mb: 2,
                  display: "flex",
                  flexDirection: "column",
                  background: "#FFFFFF08",
                  color: "white",
                  justifyContent: "space-between",
                  border: "1px solid #2C2D3C",
                  borderRadius: "8px",
                  width: "100%",
                  padding: "16px",
                  fontSize: "14px",
                  boxShadow: "0px 1px 2px 0px #1018280D",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {/* Left: Key Takeaways */}
                  <Typography
                    sx={{
                      fontStyle: "Roboto",
                      fontSize: "18px",
                      fontWeight: 700,
                      lineHeight: "18px",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <AutoAwesome sx={{ mr: 1 }} /> Key Takeaways
                  </Typography>

                  {/* Right: View Full Summary / Collapse */}
                  <Box
                    sx={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <>
                      <Button
                        onClick={toggleExpand}
                        variant="contained"
                        sx={{
                          fontStyle: "Inter",
                          fontWeight: 600,
                          fontSize: "12px",
                          color: "white",
                          padding: "6px 8px",
                          borderRadius: "4px",
                          textTransform: "none",
                          backgroundColor: "#BE3FF5",
                          "&:hover": {
                            backgroundColor: "#BE3FF5",
                          },
                        }}
                      >
                        View key takeaways
                      </Button>
                    </>
                  </Box>
                </Box>

                <Dialog
                  open={openDialog}
                  onClose={handleClose}
                  fullWidth
                  maxWidth="lg"
                  PaperProps={{
                    sx: {
                      backgroundColor: "#1C1C1E",
                      color: "white",
                      borderRadius: "12px",
                    },
                  }}
                >
                  <DialogTitle
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontWeight: 700,
                      fontSize: "18px",
                      fontStyle: "Roboto",
                      color: "white",
                    }}
                  >
                    {/* Group icon and text together */}
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <AutoAwesome sx={{ mr: 1 }} />
                      Key Takeaways
                    </Box>

                    {/* Right: Close button + Toggle buttons */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <ToggleButtonGroup
                        value={selectedView} // should be a state variable like 'keyInsights' or 'recommendations'
                        exclusive
                        onChange={handleToggleChange} // function to handle view switch
                        sx={{
                          backgroundColor: "#FFFFFF1A",
                          borderRadius: "6px",
                          "& .MuiToggleButton-root": {
                            color: "white",
                            fontSize: "12px",
                            padding: "4px 10px",
                            border: "none",
                            fontStyle: "Roboto",
                            textTransform: "none",
                            "&.Mui-selected": {
                              backgroundColor: "#BE3FF5",
                              color: "white",
                            },
                          },
                        }}
                      >
                        <ToggleButton value="keyInsights">
                          Key Insights
                        </ToggleButton>
                        <ToggleButton value="recommendations">
                          Recommendations
                        </ToggleButton>
                      </ToggleButtonGroup>
                      <IconButton onClick={handleClose} sx={{ color: "white" }}>
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  </DialogTitle>

                  <DialogContent>
                    <>
                      <Box>
                        {heatmapChartData &&
                          heatmapChartData.L2 &&
                          heatmapChartData.L2.data &&
                          Array.isArray(heatmapChartData.L2.data) &&
                          heatmapChartData.L2.data.length > 0 && (
                            <Box sx={{ mb: 2, mt: 2, ml: 1 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "16px",
                                }}
                              >
                                {selectedView === "keyInsights" && (
                                  //   {/* Volatility Highlights Section */}
                                  <Box
                                    sx={{
                                      border: "1px solid #FFFFFF1A",
                                      borderRadius: "8px",
                                      boxShadow: "0px 1px 2px 0px #1018280D",
                                      padding: "12px",
                                      backgroundColor: "#FFFFFF0F",
                                    }}
                                  >
                                    <Typography sx={{ fontWeight: 600, mb: 1 }}>
                                      Spend Evolution(
                                      {
                                        heatmapChartData.L1.previous_period
                                      } - {heatmapChartData.L1.current_period})
                                    </Typography>

                                    {/* First bullet point - Spend volatility */}
                                    <Box
                                      sx={{
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "flex-start",
                                      }}
                                    >
                                      {/* <span
        style={{
          marginRight: "8px",
          color: "#FFFFFF",
          fontSize: "14px",
        }}
      >
        •
      </span> */}
                                      <span style={{ fontSize: "14px" }}>
                                        {(() => {
                                          const sortedData =
                                            heatmapChartData.L2.data.sort(
                                              (a, b) =>
                                                Math.abs(b.pct_change) -
                                                Math.abs(a.pct_change)
                                            );

                                          const positiveChanges = sortedData
                                            .filter(
                                              (category) =>
                                                category.pct_change > 0
                                            )
                                            .slice(0, 2);

                                          const negativeChanges = sortedData
                                            .filter(
                                              (category) =>
                                                category.pct_change < 0
                                            )
                                            .slice(0, 2);

                                          const formatCategories = (
                                            categories
                                          ) =>
                                            categories.map(
                                              (category, index, arr) => (
                                                <React.Fragment
                                                  key={category.name}
                                                >
                                                  <span>
                                                    <i>
                                                      {category.name} (
                                                      <span
                                                        style={{
                                                          color: "#FFFFFF",
                                                        }}
                                                      >
                                                        {category.total_spend_pct.toFixed(
                                                          0
                                                        )}
                                                        %
                                                      </span>
                                                      )
                                                      {index === arr.length - 1
                                                        ? ""
                                                        : " and "}
                                                    </i>
                                                  </span>
                                                </React.Fragment>
                                              )
                                            );

                                          const formatPctChanges = (
                                            categories
                                          ) =>
                                            categories
                                              .map((category) => (
                                                <span
                                                  key={category.name}
                                                  style={{
                                                    display: "inline-flex",
                                                    alignItems: "center",
                                                    color:
                                                      category.pct_change >= 0
                                                        ? "#F44336"
                                                        : "#4CAF50",
                                                  }}
                                                >
                                                  <span>
                                                    {category.pct_change >= 0
                                                      ? "▲"
                                                      : "▼"}
                                                  </span>
                                                  <span
                                                    style={{
                                                      marginLeft: "4px",
                                                      lineHeight: 1,
                                                    }}
                                                  >
                                                    {category.pct_change.toFixed(
                                                      0
                                                    )}
                                                    %
                                                  </span>
                                                </span>
                                              ))
                                              .reduce((prev, curr) => [
                                                prev,
                                                " and ",
                                                curr,
                                              ]);

                                          return (
                                            <>
                                              Among the top 80% categories,{" "}
                                              {positiveChanges.length > 0 && (
                                                <>
                                                  {formatCategories(
                                                    positiveChanges
                                                  )}{" "}
                                                  {positiveChanges.length > 1
                                                    ? "have"
                                                    : "has"}{" "}
                                                  seen the most significant
                                                  increases in spend by{" "}
                                                  {formatPctChanges(
                                                    positiveChanges
                                                  )}{" "}
                                                  {positiveChanges.length > 1
                                                    ? "respectively"
                                                    : ""}
                                                </>
                                              )}
                                              {positiveChanges.length > 0 &&
                                                negativeChanges.length > 0 &&
                                                ", while "}
                                              {negativeChanges.length > 0 && (
                                                <>
                                                  {formatCategories(
                                                    negativeChanges
                                                  )}{" "}
                                                  {negativeChanges.length > 1
                                                    ? "have"
                                                    : "has"}{" "}
                                                  experienced the largest
                                                  decline by{" "}
                                                  {formatPctChanges(
                                                    negativeChanges
                                                  )}{" "}
                                                  {negativeChanges.length > 1
                                                    ? "respectively"
                                                    : ""}
                                                </>
                                              )}
                                            </>
                                          );
                                        })()}
                                      </span>
                                    </Box>
                                  </Box>
                                )}
                                {/* Category Market Outlook Section */}
                                {costStructureMovements &&
                                  costStructureMovements.length > 0 && (
                                    <Box
                                      sx={{
                                        border: "1px solid #FFFFFF1A",
                                        borderRadius: "8px",
                                        boxShadow: "0px 1px 2px 0px #1018280D",
                                        padding: "12px",
                                        backgroundColor: "#FFFFFF0F",
                                      }}
                                    >
                                      <Typography
                                        sx={{ fontWeight: 600, mb: 1 }}
                                      >
                                        {selectedView === "recommendations"
                                          ? "Category recommendations"
                                          : "Market Outlook"}
                                      </Typography>

                                      {/* Show insight_high, insight_low, and insight_moderate in bullet points */}
                                      {selectedView === "recommendations" && (
                                        <Box
                                          component="ul"
                                          sx={{
                                            paddingLeft: 2,
                                            margin: 0,
                                            listStyleType: "disc",
                                          }}
                                        >
                                          {filteredResults.recommendations.map(
                                            (recommendation, index) => (
                                              <li key={index}>
                                                <Typography
                                                  sx={{
                                                    fontSize: "14px",
                                                    color: "white",
                                                  }}
                                                >
                                                  {recommendation}
                                                </Typography>
                                              </li>
                                            )
                                          )}
                                        </Box>
                                      )}
                                      {/* Second bullet point - Price volatility */}
                                      {costStructureMovements &&
                                        costStructureMovements.length > 0 && (
                                          <Box>
                                            {selectedView === "keyInsights" && (
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  alignItems: "flex-start",
                                                  marginBottom: "12px",
                                                }}
                                              >
                                                <span
                                                  style={{
                                                    marginRight: "8px",
                                                    color: "#FFFFFF",
                                                    fontSize: "14px",
                                                  }}
                                                >
                                                  •
                                                </span>
                                                <span
                                                  style={{
                                                    fontSize: "14px",
                                                  }}
                                                >
                                                  <i>Price Evolution</i>:{" "}
                                                  {(() => {
                                                    // Sort all movements by absolute value to get top 3 highest changes
                                                    const topMovements = [
                                                      ...costStructureMovements,
                                                    ]
                                                      .sort((a, b) => {
                                                        // Find the corresponding category data for each item
                                                        const categoryA =
                                                          categoryChartDataL1.category_chart_l1.find(
                                                            (category) =>
                                                              category.name ===
                                                              a.name
                                                          );
                                                        const categoryB =
                                                          categoryChartDataL1.category_chart_l1.find(
                                                            (category) =>
                                                              category.name ===
                                                              b.name
                                                          );

                                                        // Sort by value (spend) in descending order
                                                        return (
                                                          (categoryB?.value ||
                                                            0) -
                                                          (categoryA?.value ||
                                                            0)
                                                        );
                                                      })
                                                      .slice(0, 3);

                                                    const increases =
                                                      topMovements
                                                        .filter(
                                                          (item) =>
                                                            item.movement > 0
                                                        )
                                                        .sort(
                                                          (a, b) =>
                                                            b.movement -
                                                            a.movement
                                                        );

                                                    const decreases =
                                                      topMovements
                                                        .filter(
                                                          (item) =>
                                                            item.movement < 0
                                                        )
                                                        .sort(
                                                          (a, b) =>
                                                            a.movement -
                                                            b.movement
                                                        );

                                                    // Format each category's trend description
                                                    const formatCategory = (
                                                      item
                                                    ) => {
                                                      if (item.movement > 0) {
                                                        return `${
                                                          item.category
                                                        } with <span style="color: #F44336;">▲${item.movement.toFixed(
                                                          item.movement <= 0.5
                                                            ? 2
                                                            : 0
                                                        )}%</span>`;
                                                      } else {
                                                        return `${
                                                          item.category
                                                        } with <span style="color: #4CAF50;">▼${Math.abs(
                                                          item.movement
                                                        ).toFixed(
                                                          Math.abs(
                                                            item.movement
                                                          ) <= 0.5
                                                            ? 2
                                                            : 0
                                                        )}%</span>`;
                                                      }
                                                    };

                                                    let statement =
                                                      "Among the top 3 categories, ";

                                                    // Handle case with both increases and decreases
                                                    if (
                                                      increases.length > 0 &&
                                                      decreases.length > 0
                                                    ) {
                                                      // Format increase part
                                                      if (
                                                        increases.length === 1
                                                      ) {
                                                        statement += `${formatCategory(
                                                          increases[0]
                                                        )} has increased`;
                                                      } else {
                                                        const formattedIncreases =
                                                          increases.map(
                                                            formatCategory
                                                          );
                                                        const lastIncrease =
                                                          formattedIncreases.pop();
                                                        statement += `${formattedIncreases.join(
                                                          ", "
                                                        )}${
                                                          formattedIncreases.length >
                                                          0
                                                            ? ", and "
                                                            : ""
                                                        }${lastIncrease} have increased`;
                                                      }

                                                      statement += ", while ";

                                                      // Format decrease part
                                                      if (
                                                        decreases.length === 1
                                                      ) {
                                                        statement += `${formatCategory(
                                                          decreases[0]
                                                        )} has decreased`;
                                                      } else {
                                                        const formattedDecreases =
                                                          decreases.map(
                                                            formatCategory
                                                          );
                                                        const lastDecrease =
                                                          formattedDecreases.pop();
                                                        statement += `${formattedDecreases.join(
                                                          ", "
                                                        )}${
                                                          formattedDecreases.length >
                                                          0
                                                            ? ", and "
                                                            : ""
                                                        }${lastDecrease} have decreased`;
                                                      }
                                                    }
                                                    // Handle case with only increases
                                                    else if (
                                                      increases.length > 0
                                                    ) {
                                                      const formattedIncreases =
                                                        increases.map(
                                                          formatCategory
                                                        );
                                                      if (
                                                        increases.length === 1
                                                      ) {
                                                        statement += `${formattedIncreases[0]} has increased`;
                                                      } else if (
                                                        increases.length === 2
                                                      ) {
                                                        statement += `${formattedIncreases.join(
                                                          " and "
                                                        )} have seen increase`;
                                                      } else {
                                                        const lastIncrease =
                                                          formattedIncreases.pop();
                                                        statement += `${formattedIncreases.join(
                                                          ", "
                                                        )}, and ${lastIncrease} have seen increase`;
                                                      }
                                                    }
                                                    // Handle case with only decreases
                                                    else if (
                                                      decreases.length > 0
                                                    ) {
                                                      const formattedDecreases =
                                                        decreases.map(
                                                          formatCategory
                                                        );
                                                      if (
                                                        decreases.length === 1
                                                      ) {
                                                        statement += `${formattedDecreases[0]} has seen decrease`;
                                                      } else if (
                                                        decreases.length === 2
                                                      ) {
                                                        statement += `${formattedDecreases.join(
                                                          " and "
                                                        )} have seen decrease`;
                                                      } else {
                                                        const lastDecrease =
                                                          formattedDecreases.pop();
                                                        statement += `${formattedDecreases.join(
                                                          ", "
                                                        )}, and ${lastDecrease} have seen decrease`;
                                                      }
                                                    }

                                                    statement +=
                                                      " in prices over the past 12 months";

                                                    return (
                                                      <span
                                                        dangerouslySetInnerHTML={{
                                                          __html: statement,
                                                        }}
                                                      />
                                                    );
                                                  })()}
                                                </span>
                                              </Box>
                                            )}
                                          </Box>
                                        )}

                                      {selectedView === "keyInsights" && (
                                        <Box>
                                          {topMovementsAnalysis &&
                                          Object.keys(topMovementsAnalysis)
                                            .length > 0 ? (
                                            <TableContainer
                                              sx={{
                                                borderRadius: "8px",
                                                overflow: "hidden",
                                                marginTop: "16px",
                                              }}
                                            >
                                              <Table
                                                sx={{
                                                  backgroundColor: "#FFFFFF0F",
                                                  borderRadius: "8px",
                                                }}
                                                aria-label="market outlook table"
                                              >
                                                <TableHead>
                                                  <TableRow
                                                    sx={{
                                                      fontStyle: "Roboto",
                                                    }}
                                                  >
                                                    <TableCell
                                                      sx={{
                                                        color: "white",
                                                        fontStyle: "Roboto",
                                                        fontSize: "12px",
                                                        fontWeight: 500,
                                                        borderBottom:
                                                          "1px solid #FFFFFF0F",
                                                        backgroundColor:
                                                          "#FFFFFF1F",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      Category
                                                    </TableCell>
                                                    <TableCell
                                                      sx={{
                                                        color: "white",
                                                        fontStyle: "Roboto",
                                                        fontSize: "12px",
                                                        fontWeight: 500,
                                                        borderBottom:
                                                          "1px solid #FFFFFF0F",
                                                        backgroundColor:
                                                          "#FFFFFF1F",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      Indicators
                                                    </TableCell>
                                                    <TableCell
                                                      sx={{
                                                        color: "white",
                                                        fontStyle: "Roboto",
                                                        fontSize: "12px",
                                                        fontWeight: 500,
                                                        borderBottom:
                                                          "1px solid #FFFFFF0F",
                                                        backgroundColor:
                                                          "#FFFFFF1F",
                                                        textAlign: "left",
                                                      }}
                                                    >
                                                      Outlook
                                                    </TableCell>
                                                  </TableRow>
                                                </TableHead>
                                                <TableBody
                                                  sx={{
                                                    fontStyle: "Roboto",
                                                  }}
                                                >
                                                  {Object.keys(
                                                    topMovementsAnalysis
                                                  )
                                                    .filter(
                                                      (category) =>
                                                        category !==
                                                        "recommendation"
                                                    ) // Exclude 'recommendation'
                                                    .sort(
                                                      (a, b) =>
                                                        Math.abs(
                                                          topMovementsAnalysis[
                                                            b
                                                          ].movement
                                                        ) -
                                                        Math.abs(
                                                          topMovementsAnalysis[
                                                            a
                                                          ].movement
                                                        )
                                                    )
                                                    .map((category) => {
                                                      const categoryData =
                                                        topMovementsAnalysis[
                                                          category
                                                        ];
                                                      const analysis =
                                                        categoryData.analysis ||
                                                        "No analysis available";

                                                      // Parse the analysis text to extract summary, indicators, and sources
                                                      const analysisParts =
                                                        analysis.split(
                                                          "Sources:"
                                                        );
                                                      const summaryText =
                                                        analysisParts[0]
                                                          .split(
                                                            "Indicators:"
                                                          )[0]
                                                          .replace(
                                                            "Summary:",
                                                            ""
                                                          )
                                                          .trim();

                                                      let sources = [];
                                                      if (
                                                        analysisParts.length > 1
                                                      ) {
                                                        // Try to parse sources from the text
                                                        try {
                                                          const sourcesText =
                                                            analysisParts[1].trim();
                                                          // If sources are in format [url1, url2, url3]
                                                          if (
                                                            sourcesText.startsWith(
                                                              "["
                                                            ) &&
                                                            sourcesText.endsWith(
                                                              "]"
                                                            )
                                                          ) {
                                                            // Remove brackets and split by commas
                                                            sources =
                                                              sourcesText
                                                                .substring(
                                                                  1,
                                                                  sourcesText.length -
                                                                    1
                                                                )
                                                                .split(",")
                                                                .map((url) =>
                                                                  url
                                                                    .trim()
                                                                    .replace(
                                                                      /^'|'$/g,
                                                                      ""
                                                                    )
                                                                );
                                                          }
                                                        } catch (e) {
                                                          console.error(
                                                            "Error parsing sources:",
                                                            e
                                                          );
                                                        }
                                                      }

                                                      // Alternatively, if sources are directly in the categoryData
                                                      if (
                                                        categoryData.sources &&
                                                        Array.isArray(
                                                          categoryData.sources
                                                        )
                                                      ) {
                                                        sources =
                                                          categoryData.sources;
                                                      }

                                                      // Parse the indicators from the analysis text
                                                      let indicators = {};

                                                      if (
                                                        analysis.includes(
                                                          "Indicators:"
                                                        )
                                                      ) {
                                                        [
                                                          "DEMAND",
                                                          "SUPPLY",
                                                          "PRICING",
                                                        ].forEach(
                                                          (indicator) => {
                                                            const regex =
                                                              new RegExp(
                                                                `${indicator}: (INCREASING|DECREASING|STABLE)`
                                                              );
                                                            const match =
                                                              analysis.match(
                                                                regex
                                                              );
                                                            const trend = match
                                                              ? match[1]
                                                              : "N/A";

                                                            // Set arrow and color based on indicator type and trend
                                                            let color =
                                                              "yellow"; // Default for STABLE
                                                            let arrow = (
                                                              <PlayArrow
                                                                sx={{
                                                                  fontSize: 14,
                                                                }}
                                                              />
                                                            );

                                                            if (
                                                              trend ===
                                                              "INCREASING"
                                                            ) {
                                                              arrow = "▲";
                                                              // For DEMAND and PRICE, INCREASING is red; for SUPPLY, it's green
                                                              color =
                                                                indicator ===
                                                                "SUPPLY"
                                                                  ? "green"
                                                                  : "red";
                                                            } else if (
                                                              trend ===
                                                              "DECREASING"
                                                            ) {
                                                              arrow = "▼";
                                                              // For DEMAND and PRICE, DECREASING is green; for SUPPLY, it's red
                                                              color =
                                                                indicator ===
                                                                "SUPPLY"
                                                                  ? "red"
                                                                  : "green";
                                                            } else if (
                                                              trend === "STABLE"
                                                            ) {
                                                              arrow = (
                                                                <PlayArrow
                                                                  sx={{
                                                                    fontSize: 14,
                                                                  }}
                                                                />
                                                              );
                                                              color = "yellow";
                                                            }

                                                            indicators[
                                                              indicator.toLowerCase()
                                                            ] = {
                                                              arrow,
                                                              color,
                                                              trend,
                                                            };
                                                          }
                                                        );
                                                      }

                                                      return (
                                                        <TableRow
                                                          key={category}
                                                          sx={{
                                                            borderBottom:
                                                              "1px solid #FFFFFF0F",
                                                            fontSize: "14px",
                                                            fontWeight: 500,
                                                            lineHeight: "20px",
                                                            textAlign: "left",
                                                            "& td, & th": {
                                                              borderBottom:
                                                                "none",
                                                            },
                                                          }}
                                                        >
                                                          <TableCell
                                                            sx={{
                                                              color: "white",
                                                              fontSize: "12px",
                                                              width: "15%",
                                                            }}
                                                          >
                                                            {category}
                                                          </TableCell>
                                                          <TableCell
                                                            sx={{
                                                              color: "white",
                                                              fontSize: "12px",
                                                              width: "25%",
                                                            }}
                                                          >
                                                            <Box
                                                              sx={{
                                                                display: "flex",
                                                                flexDirection:
                                                                  "row",
                                                                gap: "12px",
                                                              }}
                                                            >
                                                              <Typography
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  fontSize:
                                                                    "12px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                Demand
                                                                {indicators.demand ? (
                                                                  <span
                                                                    style={{
                                                                      display:
                                                                        "inline-flex", // Ensures inline flex for alignment
                                                                      alignItems:
                                                                        "center", // Vertical alignment
                                                                      color:
                                                                        indicators
                                                                          .demand
                                                                          .color,
                                                                      fontWeight:
                                                                        "bold",
                                                                      marginLeft:
                                                                        "4px",
                                                                    }}
                                                                  >
                                                                    {
                                                                      indicators
                                                                        .demand
                                                                        .arrow
                                                                    }
                                                                  </span>
                                                                ) : (
                                                                  "N/A"
                                                                )}
                                                              </Typography>

                                                              <Typography
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  fontSize:
                                                                    "12px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                Supply
                                                                {indicators.supply ? (
                                                                  <span
                                                                    style={{
                                                                      display:
                                                                        "inline-flex", // Ensures inline flex for alignment
                                                                      alignItems:
                                                                        "center", // Vertical alignment
                                                                      color:
                                                                        indicators
                                                                          .supply
                                                                          .color,
                                                                      fontWeight:
                                                                        "bold",
                                                                      marginLeft:
                                                                        "4px",
                                                                    }}
                                                                  >
                                                                    {
                                                                      indicators
                                                                        .supply
                                                                        .arrow
                                                                    }
                                                                  </span>
                                                                ) : (
                                                                  "N/A"
                                                                )}
                                                              </Typography>
                                                              <Typography
                                                                sx={{
                                                                  display:
                                                                    "flex",
                                                                  alignItems:
                                                                    "center",
                                                                  fontSize:
                                                                    "12px",
                                                                  fontWeight:
                                                                    "bold",
                                                                }}
                                                              >
                                                                Pricing
                                                                {indicators.pricing ? (
                                                                  <span
                                                                    style={{
                                                                      display:
                                                                        "inline-flex", // Ensures inline flex for alignment
                                                                      alignItems:
                                                                        "center", // Vertical alignment
                                                                      color:
                                                                        indicators
                                                                          .pricing
                                                                          .color,
                                                                      fontWeight:
                                                                        "bold",
                                                                      marginLeft:
                                                                        "4px",
                                                                    }}
                                                                  >
                                                                    {
                                                                      indicators
                                                                        .pricing
                                                                        .arrow
                                                                    }
                                                                  </span>
                                                                ) : (
                                                                  "N/A"
                                                                )}
                                                              </Typography>
                                                            </Box>
                                                          </TableCell>
                                                          <TableCell
                                                            sx={{
                                                              color: "white",
                                                              fontSize: "12px",
                                                              // width: "60%",
                                                            }}
                                                          >
                                                            <Typography
                                                              sx={{
                                                                fontSize:
                                                                  "12px",
                                                                fontFamily:
                                                                  "Inter",
                                                                // fontWeight:600,
                                                                lineHeight:
                                                                  "1.4",
                                                              }}
                                                            >
                                                              {summaryText
                                                                .replace(
                                                                  /['"]/g,
                                                                  ""
                                                                )
                                                                .split("***")
                                                                .filter(
                                                                  (item) =>
                                                                    item.trim()
                                                                ) // Keep only non-empty items
                                                                .map(
                                                                  (
                                                                    item,
                                                                    index
                                                                  ) => {
                                                                    // Find the key and format it
                                                                    const match =
                                                                      item.match(
                                                                        /([A-Z]+):(.*)/
                                                                      );
                                                                    let keyPart =
                                                                      null;
                                                                    let contentPart =
                                                                      item;

                                                                    if (match) {
                                                                      const key =
                                                                        match[1];
                                                                      const formattedKey =
                                                                        key
                                                                          .charAt(
                                                                            0
                                                                          )
                                                                          .toUpperCase() +
                                                                        key
                                                                          .slice(
                                                                            1
                                                                          )
                                                                          .toLowerCase();
                                                                      keyPart =
                                                                        (
                                                                          <b>
                                                                            {
                                                                              formattedKey
                                                                            }
                                                                            :
                                                                          </b>
                                                                        );
                                                                      contentPart =
                                                                        match[2];
                                                                    }

                                                                    // Strip content from parentheses and square brackets
                                                                    contentPart = contentPart.replace(/\([^)]*\)|\[[^\]]*\]|\*|\)|\]/g, "");

                                                                    // Only render if there's actual content after trimming
                                                                    const trimmedContent =
                                                                      contentPart.trim();
                                                                    if (
                                                                      !trimmedContent
                                                                    )
                                                                      return null; // Skip empty content

                                                                    return (
                                                                      <div
                                                                        key={
                                                                          index
                                                                        }
                                                                        style={{
                                                                          display:
                                                                            "flex",
                                                                          alignItems:
                                                                            "flex-start",
                                                                          marginBottom:
                                                                            "6px",
                                                                        }}
                                                                      >
                                                                        <span
                                                                          style={{
                                                                            marginRight:
                                                                              "8px",
                                                                            
                                                                            color:
                                                                              "#FFFFFF",
                                                                            fontSize:
                                                                              "14px",
                                                                          }}
                                                                        >
                                                                          •
                                                                        </span>
                                                                        <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "6px" }}>
  {/* <span style={{ marginRight: "8px", color: "#FFFFFF", fontSize: "14px" }}>•</span> */}
  <Typography
      component="span"
    sx={{
      fontSize: "12px",
    //   fontFamily: "Inter",
    //   lineHeight: "1.4",
      color: "white",
    }}
  >
    {keyPart} {trimmedContent}
  </Typography>
</div>

                                                                      </div>
                                                                    );
                                                                  }
                                                                )
                                                                .filter(
                                                                  Boolean
                                                                )}
                                                            </Typography>

                                                            {/* Display Sources */}
                                                            {sources &&
                                                              sources.length >
                                                                0 && (
                                                                <Box
                                                                  sx={{
                                                                    marginTop:
                                                                      "8px",
                                                                    display:
                                                                      "flex",
                                                                    flexWrap:
                                                                      "wrap",
                                                                    gap: "8px",
                                                                    marginLeft:
                                                                      "12px",
                                                                  }}
                                                                >
                                                                  <Typography
                                                                    component="span"
                                                                    sx={{
                                                                      fontSize:
                                                                        "12px",
                                                                      fontWeight:
                                                                        "bold",
                                                                    }}
                                                                  >
                                                                    Sources:
                                                                  </Typography>
                                                                  {sources.map(
                                                                    (
                                                                      url,
                                                                      index
                                                                    ) => {
                                                                      // Extract domain name from URL
                                                                      let siteName;
                                                                      try {
                                                                        const domain =
                                                                          new URL(
                                                                            url
                                                                          )
                                                                            .hostname;
                                                                        // Convert domain to site name (e.g., www.reuters.com -> reuters)
                                                                        siteName =
                                                                          domain
                                                                            .replace(
                                                                              "www.",
                                                                              ""
                                                                            )
                                                                            .split(
                                                                              "."
                                                                            )[0];
                                                                        // Capitalize first letter
                                                                        siteName =
                                                                          siteName
                                                                            .charAt(
                                                                              0
                                                                            )
                                                                            .toUpperCase() +
                                                                          siteName.slice(
                                                                            1
                                                                          );
                                                                      } catch (e) {
                                                                        siteName = `Source ${
                                                                          index +
                                                                          1
                                                                        }`;
                                                                      }

                                                                      return (
                                                                        <Typography
                                                                          key={
                                                                            index
                                                                          }
                                                                          component="a"
                                                                          href={
                                                                            url
                                                                          }
                                                                          target="_blank"
                                                                          rel="noopener noreferrer"
                                                                          sx={{
                                                                            fontSize:
                                                                              "12px",
                                                                            color:
                                                                              "#4dabf5",
                                                                            textDecoration:
                                                                              "none",
                                                                            "&:hover":
                                                                              {
                                                                                textDecoration:
                                                                                  "underline",
                                                                              },
                                                                            display:
                                                                              "inline-block",
                                                                          }}
                                                                        >
                                                                          {
                                                                            siteName
                                                                          }
                                                                          {index <
                                                                          sources.length -
                                                                            1
                                                                            ? ","
                                                                            : ""}
                                                                        </Typography>
                                                                      );
                                                                    }
                                                                  )}
                                                                </Box>
                                                              )}
                                                          </TableCell>
                                                        </TableRow>
                                                      );
                                                    })}
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          ) : (
                                            <Skeleton
                                              width="100%"
                                              height={20}
                                            />
                                          )}
                                        </Box>
                                      )}
                                    </Box>
                                  )}

                                {/* Supplier Risk Assessment Section */}

                                {topcardCommentary &&
                                  Object.entries(topcardCommentary).length >
                                    0 && (
                                    <Box
                                      sx={{
                                        border: "1px solid #FFFFFF1A",
                                        borderRadius: "8px",
                                        boxShadow: "0px 1px 2px 0px #1018280D",
                                        padding: "12px",
                                        backgroundColor: "#FFFFFF0F",
                                      }}
                                    >
                                      <Typography
                                        sx={{ fontWeight: 600, mb: 1 }}
                                      >
                                        {selectedView === "recommendations"
                                          ? "Supplier recommendations"
                                          : "Supplier Risk Assessment"}
                                      </Typography>

                                      <Box
                                        sx={{
                                          display: "flex",
                                          flexDirection: "column",
                                          alignItems: "flex-start",
                                        }}
                                      >
                                        {/* Show full_insight value at the top */}
                                        {topcardCommentary.full_insight && (
                                          <Typography
                                            sx={{
                                              fontSize: "14px",
                                              mb: 1,
                                              color: "white",
                                            }}
                                          >
                                            {topcardCommentary.full_insight}
                                          </Typography>
                                        )}

                                        {/* Show insight_high, insight_low, and insight_moderate in bullet points */}
                                        {selectedView === "recommendations" && (
                                          <Box
                                            component="ul"
                                            sx={{
                                              paddingLeft: 2,
                                              margin: 0,
                                              listStyleType: "disc",
                                            }}
                                          >
                                            {[
                                              "insight_high",
                                              "insight_low",
                                              "insight_moderate",
                                            ]
                                              .filter(
                                                (key) => topcardCommentary[key]
                                              )
                                              .map((key) => (
                                                <li key={key}>
                                                  <Typography
                                                    sx={{
                                                      fontSize: "14px",
                                                      color: "white",
                                                    }}
                                                  >
                                                    {topcardCommentary[key]}
                                                  </Typography>
                                                </li>
                                              ))}
                                          </Box>
                                        )}
                                      </Box>
                                    </Box>
                                  )}
                              </Box>
                            </Box>
                          )}
                      </Box>
                    </>
                  </DialogContent>
                </Dialog>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Spend Overview Section */}
      <Box
        id="Spend Overview"
        className="pdf-section-CPO"
        sx={{
          mb: 4,
          mt: 4,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            flex: 1,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontStyle: "Roboto",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "18px",
                color: "white",
                gap: "7px",
              }}
            >
              <Toll
                sx={{
                  mr: 0.5,
                  width: "16px",
                  height: "16px",
                  color: "#FFFFFF99",
                }}
              />
              Spend Overview
            </Typography>
          </Box>

          <Box
            sx={{
              height: "1px",
              backgroundColor: "#FFFFFF29",
              flex: 1,
            }}
          />
        </Box>
        <Box sx={{ width: "100%", height: "1px", mb: 2 }} />

        <Grid container spacing={3} sx={{ height: "240px" }}>
          <Grid item xs={12} md={3} sx={{ height: "100%" }}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {spendSummary.spend_summary.overall_spend ? (
                <AnimatedInfoCard
                  delay={1000}
                  // icon={cardsCPO.icon}
                  title={cardsCPO.title}
                  content={cardsCPO.content}
                />
              ) : (
                <LoadingGif />
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={3} sx={{ height: "100%" }}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {categorySummary.category_summary.num_l1_categories ? (
                <AnimatedInfoCard
                  delay={2000}
                  // icon={cardsCPO1.icon}
                  title={cardsCPO1.title}
                  content={cardsCPO1.content}
                />
              ) : (
                <LoadingGif />
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={3} sx={{ height: "100%" }}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {supplierSummary.supplier_summary.total_suppliers ? (
                <AnimatedInfoCard
                  delay={3000}
                  // icon={cardsCPO2.icon}
                  title={cardsCPO2.title}
                  content={cardsCPO2.content}
                />
              ) : (
                <LoadingGif />
              )}
            </Box>
          </Grid>

          <Grid item xs={12} md={3} sx={{ height: "100%" }}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {supplierSummary.supplier_summary.total_suppliers ? (
                <AnimatedInfoCard
                  delay={3000}
                  // icon={cardsCPO3.icon}
                  title={cardsCPO3.title}
                  content={cardsCPO3.content}
                />
              ) : (
                <LoadingGif />
              )}
            </Box>
          </Grid>
        </Grid>

        {/* {loading && !dashboardData && <LoadingGif />} */}
      </Box>

      {/* Category Overview Section */}
      <Box
        id="Category Spend Summary"
        style={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            flex: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <RxDashboard
              style={{
                width: "14px",
                height: "14px",
                color: "#FFFFFF99",
              }}
            />
            <Typography
              sx={{
                fontStyle: "Roboto",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "18px",
                color: "white",
              }}
            >
              Category Insights
            </Typography>
          </Box>
          <Box
            sx={{
              height: "1px",
              backgroundColor: "#FFFFFF29",
              flex: 1,
            }}
          />
        </Box>
        <Box sx={{ width: "100%", height: "1px", mb: 2, width: "100%" }} />
        <Box
          sx={{
            // backgroundColor: "#FFFFFF08",
            // borderRadius: "8px",
            padding: 2,
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "16px",
              flex: 1,
              marginBottom: "32px",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                fontStyle: "Roboto",
                fontSize: "16px",
                fontWeight: 400,
                lineHeight: "18px",
                color: "white",
                gap: "7px",
                display: "inline-flex", // Change to inline-flex
                alignItems: "center",
                cursor: "pointer",
                position: "relative", // Add this
                zIndex: 1, // Add this
              }}
            >
              <AttachMoney
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#FFFFFF99",
                }}
              />
              Spend Overview
            </Typography>
            <Box
              sx={{
                height: "1px",
                backgroundColor: "#FFFFFF29",
                flex: 1,
              }}
            />
          </Box>
          {categoryChartData && categoryChartDataL1 && (
            //  <Box sx={{ backgroundColor: "rgba(129, 129, 129, 0.25)", borderRadius: "30px", padding: 2, width: "100%" }}>
            <Fade in={true} timeout={1000}>
              <Box
              className="pdf-section-CPO"
                style={{
                  width: "100%",
                  // height: "60vh",
                  // marginBottom: "6rem",
                }}
              >
                <HistogramChart
                  chartData={categoryChartData}
                  categoryChartDataL1={categoryChartDataL1}
                  spendSummary={spendSummary}
                  roleTitle={roleTitle}
                  heatmapChartData={heatmapChartData}
                  barColor="lightblue"
                />
              </Box>
            </Fade>
            //  </Box>
          )}

          {/* {topCategories != "" ? (
          // <Box sx={{ backgroundColor: "rgba(129, 129, 129, 0.25)", borderRadius: "30px", padding: 2, width: "100%" }}>

          <InsightContainer
            title="Insights"
            topCategories={topCategories}
            topContributors={topContributors}
            marketSize={marketSize}
            categoryDict={categoryDict}
            costStructure={costStructure}
            demandandSupply={demandandSupply}
            topSuppliers={topSuppliers}
            categoryChartData={categoryChartData}
            categoryChartDataL1={categoryChartDataL1}
            clientNames={clientNames}
            categoryNews={categoryNews}
            indiSummaries={indiSummaries}
            globalSummaries={globalSummaries}
            csSrc={csSrc}
          />
        ) : (
          // </Box>
          <LoadingGif />
        )} */}

          {/* <div style={{ marginTop: "4rem" }}>
          {filteredResults.result &&
          Object.keys(filteredResults.result).length > 0 ? (
            <CPOCommodityPriceChart
              filteredResults={filteredResults.result}
              costStructureMovements={costStructureMovements}
              spendSummary={spendSummary}
            />
          ) : (
            <LoadingGif />
          )}
        </div> */}
        </Box>
      </Box>

      {/* {Market Insights Section} */}
      <Box
        id="Market Insights"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          mt: 4,
          ml: 3,
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            flex: 1,
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontStyle: "Roboto",
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "18px",
              color: "white",
              gap: "7px",
              display: "inline-flex", // Change to inline-flex
              alignItems: "center",
              cursor: "pointer",
              position: "relative", // Add this
              zIndex: 1, // Add this
            }}
          >
            <Campaign
              sx={{
                width: "16px",
                height: "16px",
                color: "#FFFFFF99",
              }}
            />
            Market Insights
          </Typography>
          <Box
            sx={{
              height: "1px",
              backgroundColor: "#FFFFFF29",
              flex: 1,
            }}
          />
        </Box>
        <Box sx={{ width: "100%", height: "1px", mb: 0, width: "100%" }} />
        <Box
          sx={{
            // backgroundColor: "#FFFFFF08",
            borderRadius: "8px",
            padding: 2,
            width: "100%",
          }}
        >
          {/* <div>
            {filteredResults.result &&
            Object.keys(filteredResults.result).length > 0 ? (
              <CPOCommodityPriceChart
                filteredResults={filteredResults.result}
                costStructureMovements={costStructureMovements}
                spendSummary={spendSummary}
              />
            ) : (
              <LoadingGif />
            )}
          </div> */}
          <div>
            {categoryNews && Object.keys(categoryNews).length > 0 ? (
              <Fade in={true} timeout={1000}>
                <Box
                  style={{
                    width: "100%",
                    // height: "110vh",
                    marginBottom: "2rem",
                  }}
                >
                  <CPOMarketInsights
                    categoryNews={categoryNews}
                    indiSummaries={indiSummaries}
                    globalSummaries={globalSummaries}
                    filteredResults={filteredResults.result}
                  />
                </Box>
              </Fade>
            ) : (
              <LoadingGif />
            )}
          </div>
        </Box>
      </Box>



      {/* Supplier Overview Section */}
      <Box id="Supplier Overview" sx={{ mt: 4 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            flex: 1,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: "5px" }}>
            <Typography
              sx={{
                fontStyle: "Roboto",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "18px",
                color: "white",
              }}
            >
              <RiBuildingLine
                style={{
                  width: "14px",
                  height: "14px",
                  color: "#FFFFFF99",
                  marginRight: 4,
                }}
              />
              Supplier Overview
            </Typography>
          </Box>
          <Box
            sx={{
              height: "1px",
              backgroundColor: "#FFFFFF29",
              flex: 1,
            }}
          />
        </Box>
        <Box sx={{ width: "100%", height: "1px", mb: 2 }} />
        <Box
          sx={{
            // backgroundColor: "#FFFFFF08",
            borderRadius: "8px",
            padding: 2,
          }}
        >
          {supplierChartData && (
            <Fade in={true} timeout={1000}>
              <Box
              className="pdf-section-CPO"
                style={{
                  width: "100%",
                  // height: "80vh",
                  marginBottom: "2rem",
                }}
              >
                <SupplierChartFunc
                  supplierChartData={supplierChartData}
                  spendSummary={spendSummary}
                  roleTitle={roleTitle}
                />
                {/* <SupplierTableFunc supplierTableData={supplierTableData} /> */}
              </Box>
            </Fade>
          )}
          {top3CategoriesSup != "" ? (
            <SupplierInsightContainer
              title="Insights"
              // supplierChartData={supplierChartData}
              // insights={supplierInsights}
              top3CategoriesSup={top3CategoriesSup}
              supDandP={supDandP}
              supCustInfo={supCustInfo}
              riskScore={riskScore}
              scoreCommentary={scoreCommentary}
              revenue={revenue}
              supplierNews={supplierNews}
              spendSummary={spendSummary}
              supplierProData={supplierProData}
              kpdbData={kpdbData}
              roleTitle={roleTitle}
            />
          ) : (
            // </Box>
            <LoadingGif />
          )}
        </Box>
      </Box>

            {/* {Carbon Chart Section} */}
            <Box
            className="pdf-section-CPO"
        id="Carbon Emissions"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          mt: 4,
          // ml: 3,
          position: "relative",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            flex: 1,
          }}
        >
          <MUITooltip
            title={
              <Typography sx={{ fontStyle: "italic", fontSize: "14px" }}>
                Indicates Scope 3 emissions by category
              </Typography>
            }
            arrow
            placement="right"
            enterDelay={500}
            leaveDelay={200}
          >
            <Typography
              variant="h6"
              sx={{
                fontStyle: "Roboto",
                fontSize: "16px",
                fontWeight: 700,
                lineHeight: "18px",
                color: "white",
                gap: "7px",
                display: "inline-flex", // Change to inline-flex
                alignItems: "center",
                cursor: "pointer",
                position: "relative", // Add this
                zIndex: 1, // Add this
              }}
            >
              <EnergySavingsLeaf
                sx={{
                  width: "16px",
                  height: "16px",
                  color: "#FFFFFF99",
                }}
              />
              Carbon Emissions
            </Typography>
          </MUITooltip>
          <Box
            sx={{
              height: "1px",
              backgroundColor: "#FFFFFF29",
              flex: 1,
            }}
          />
        </Box>
        <Box sx={{ width: "100%", height: "1px", width: "100%" }} />
        <Box
          sx={{
            // backgroundColor: "#FFFFFF08",
            borderRadius: "8px",
            padding: 2,
            width: "100%",
          }}
        >
          {spendSummary &&
          carbonEmission &&
          Object.keys(carbonEmission).length > 0 ? (
            <Fade in={true} timeout={1000}>
              <Box
                style={{
                  width: "100%",
                  // height: "110vh",
                  marginBottom: "2rem",
                }}
              >
                <CarbonChart
                  carbonEmission={carbonEmission}
                  carbonTable={carbonTable}
                  spendSummary={spendSummary}
                />
              </Box>
            </Fade>
          ) : (
            <LoadingGif />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default AnalyticsSectionCPO;
